const CONFIG = {
  companyName: 'Dynamic Business Solution for IT',
  companyNameAr: 'ديناميك بيزنس سوليوشن لتقنية المعلومات',
  commercialRegistration: '1009112587',
  phone: '+966541022226',
  address: '7277 طـريق الملك فـهد - العليا ،بـرج الفيصلية الرياض',
  email: 'info@dynamicksa.com',
  facebookUrl: 'https://www.facebook.com/profile.php?id=61554149536363',
  linkedInUrl: 'https://www.linkedin.com/company/5363220/admin/feed/posts/',
};

const ARABIC_COUNTRY_CODES = [
  'dz', // Algeria
  'bh', // Bahrain
  'eg', // Egypt
  'iq', // Iraq
  'jo', // Jordan
  'kw', // Kuwait
  'om', // Oman
  'qa', // Qatar
  'sa', // Saudi Arabia
  'ae', // United Arab Emirates
  'ye', // Yemen
];

export default CONFIG;
export { ARABIC_COUNTRY_CODES };
